import React from "react";
import CountdownTimer from "../custom_hooks/timer";
import coin from "../../assets/img/icons/coin.avif";

import { makeAPI } from "../../services/api";

{/* Tournaments Section */ }

export default function Tournaments() {
  const imagePath = "/images/tournament-cards/";
  const [tournaments, setTournaments] = React.useState([]);
  const swiperRef = React.useRef(null);

  React.useEffect(() => {
    const fetchTournaments = async () => {
      try {
        const response = await makeAPI('/api/tournament');
        setTournaments(response.data);

        // Initialize Swiper after data is fetched
        const swiperElement = document.querySelector(".js-popular .swiper");
        if (!swiperElement) return;
        if (swiperElement.swiper && !swiperElement.swiper.destroyed) {
          swiperElement.swiper.destroy(true, true);
        }

        swiperRef.current = new Swiper(".js-popular .swiper", {
          slidesPerView: 1,
          spaceBetween: 25,
          loop: false,
          watchOverflow: true,
          observeParents: true,
          observeSlideChildren: true,
          observer: true,
          speed: 800,
          autoplay: {
            delay: 5000
          },
          navigation: {
            nextEl: '.js-popular .swiper-button-next',
            prevEl: '.js-popular .swiper-button-prev'
          },
          pagination: {
            el: '.js-popular .swiper-pagination',
            type: 'bullets',
            // 'bullets', 'fraction', 'progressbar'
            clickable: true
          },
          breakpoints: {
            575: {
                slidesPerView: 2,
                spaceBetween: 25
            },
            1199: {
                slidesPerView: 3,
                spaceBetween: 25
            },
            1599: {
                slidesPerView: 4,
                spaceBetween: 25
            }
          }
        });
      } catch (error) {
        console.error('Error fetching tournaments:', error);
      }
    };
    fetchTournaments();

    return () => {
      if (swiperRef.current && !swiperRef.current.destroyed) {
        swiperRef.current.destroy(true, true);
      }
      swiperRef.current = null;
    };
  }, []);

  return (
    <>

      {
        <div className="uk-width-1-1 uk-margin-large-top" id="tournaments-section">
          <h3 className="uk-text-lead">Live Tournaments</h3>
          <div className="js-popular">
            <div className="swiper">
              <div className="swiper-wrapper">
                {tournaments.length === 0 && <p>No tournaments available at the moment.</p>}
                {tournaments.map((tournament, idx) => {
                  let tournament_duration =  "7 Days";
                  return (
                    <div className="swiper-slide" key={idx}>

                      <div className="fl-gp-box">
                        <div className="fl-cover-image">
                          <img alt="group" src={`${imagePath}${tournament.event_icon}`} />
                          <div className="fl-gp-info-wrap">
                            <div className="fl-gp-info">
                              <div className="fl-gp-title">
                                <a href="14_group.html" className="bp-gp-home-link season-of-the-witch-home-link">{tournament?.event_title.toUpperCase() || ""}</a>
                              </div>
                              <div className="fl-gp-meta">
                                <div className="group-status"> <i className="icon-globe"></i><span style={{ color: tournament.tournament_status === "live" ? "red" : tournament.tournament_status === "upcoming" ? "#ff810e" : "green", fontWeight:"bolder"}}>{tournament.tournament_status?.toUpperCase() || ""}</span></div>
                              </div>
                            </div>
                            <div className="fl-gp-avatar"> <a href="04_profile.html" className="item-avatar">
                              <img className="avatar" width="100" height="100" alt="Profile Photo" src="assets/img/user-1.png" />
                            </a> </div>
                          </div>
                        </div>
                        <div className="fl-gp-footer">
                          <div className="fl-gp-cells">
                            <div className="fl-gp-cell-left">
                              <strong><img src={coin} width="18" height="18" alt="Coin icon" style={{ margin: "-3px 0px 0px 0px", verticalAlign: "middle" }}/>&nbsp;{tournament.prize_pool}</strong>
                              <span>Prize Pool</span>
                            </div>
                            <div className="fl-gp-cell-right">
                              <strong> {tournament_duration}</strong>
                              <span>Duration</span>
                            </div>
                          </div>
                          <div className="fl-gp-action">
                            <div className="">
                              <span className="fl-gp-active">Ends on:&nbsp;<span style={{color:"#ff810e"}}>{tournament.tournament_date.end +" (IST)"}</span></span>
                              <span className="fl-gp-active"><i className="fa fa-clock"></i><CountdownTimer remainingSeconds={tournament?.end_time || 0} onTimerEnd={() => console.log("Timer ended for tournament:")} /></span>
                            </div>
                            <div className="fl-gp-button">
                              <a className="fl-gp-button fl-join-group" rel="join" href={`/tournaments/${tournament.game_id}/${tournament.event_id}`}><i className="gg-icon gg-log-in"></i> Play</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
                }
              </div>
              <div className="swiper-button-prev"></div>
              <div className="swiper-button-next"></div>
              <div className="swiper-pagination"></div>
            </div>
          </div>
        </div>
      }
    </>
  );
}

